import { render, staticRenderFns } from "./admin-purshase-product.vue?vue&type=template&id=ad022188&scoped=true"
import script from "./admin-purshase-product.vue?vue&type=script&lang=js"
export * from "./admin-purshase-product.vue?vue&type=script&lang=js"
import style0 from "./admin-purshase-product.vue?vue&type=style&index=0&id=ad022188&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad022188",
  null
  
)

export default component.exports